export const blockIconsPhotoandimageCropSquareNew = (
	<span className='material-symbols-outlined'>crop_square</span>
);
